import DownloadsTemplate from "./DownloadsTemplate";

export default function FinancialStatements() {
  const files = [
    {
      titleKey: "governance.financialStatements.files.1.title",
      descKey: "governance.financialStatements.files.1.desc",
      url: "#"
    }
  ];

  return (
    <DownloadsTemplate
      titleKey="governance.financialStatements.title"
      descriptionKey="governance.financialStatements.description"
      files={files}
      seoTitleKey="governance.financialStatements.seo.title"
      seoDescKey="governance.financialStatements.seo.description"
      seoPath="/governance/financial-statements"
    />
  );
}